import _classCallCheck from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/** Base class for errors */
export var TokenError = /*#__PURE__*/function (_Error) {
  _inherits(TokenError, _Error);

  var _super = _createSuper(TokenError);

  function TokenError(message) {
    _classCallCheck(this, TokenError);

    return _super.call(this, message);
  }

  return TokenError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/** Thrown if an account is not found at the expected address */

export var TokenAccountNotFoundError = /*#__PURE__*/function (_TokenError) {
  _inherits(TokenAccountNotFoundError, _TokenError);

  var _super2 = _createSuper(TokenAccountNotFoundError);

  function TokenAccountNotFoundError() {
    var _this;

    _classCallCheck(this, TokenAccountNotFoundError);

    _this = _super2.apply(this, arguments);
    _this.name = 'TokenAccountNotFoundError';
    return _this;
  }

  return TokenAccountNotFoundError;
}(TokenError);
/** Thrown if a program state account is not a valid Account */

export var TokenInvalidAccountError = /*#__PURE__*/function (_TokenError2) {
  _inherits(TokenInvalidAccountError, _TokenError2);

  var _super3 = _createSuper(TokenInvalidAccountError);

  function TokenInvalidAccountError() {
    var _this2;

    _classCallCheck(this, TokenInvalidAccountError);

    _this2 = _super3.apply(this, arguments);
    _this2.name = 'TokenInvalidAccountError';
    return _this2;
  }

  return TokenInvalidAccountError;
}(TokenError);
/** Thrown if a program state account does not contain valid data */

export var TokenInvalidAccountDataError = /*#__PURE__*/function (_TokenError3) {
  _inherits(TokenInvalidAccountDataError, _TokenError3);

  var _super4 = _createSuper(TokenInvalidAccountDataError);

  function TokenInvalidAccountDataError() {
    var _this3;

    _classCallCheck(this, TokenInvalidAccountDataError);

    _this3 = _super4.apply(this, arguments);
    _this3.name = 'TokenInvalidAccountDataError';
    return _this3;
  }

  return TokenInvalidAccountDataError;
}(TokenError);
/** Thrown if a program state account is not owned by the expected token program */

export var TokenInvalidAccountOwnerError = /*#__PURE__*/function (_TokenError4) {
  _inherits(TokenInvalidAccountOwnerError, _TokenError4);

  var _super5 = _createSuper(TokenInvalidAccountOwnerError);

  function TokenInvalidAccountOwnerError() {
    var _this4;

    _classCallCheck(this, TokenInvalidAccountOwnerError);

    _this4 = _super5.apply(this, arguments);
    _this4.name = 'TokenInvalidAccountOwnerError';
    return _this4;
  }

  return TokenInvalidAccountOwnerError;
}(TokenError);
/** Thrown if the byte length of an program state account doesn't match the expected size */

export var TokenInvalidAccountSizeError = /*#__PURE__*/function (_TokenError5) {
  _inherits(TokenInvalidAccountSizeError, _TokenError5);

  var _super6 = _createSuper(TokenInvalidAccountSizeError);

  function TokenInvalidAccountSizeError() {
    var _this5;

    _classCallCheck(this, TokenInvalidAccountSizeError);

    _this5 = _super6.apply(this, arguments);
    _this5.name = 'TokenInvalidAccountSizeError';
    return _this5;
  }

  return TokenInvalidAccountSizeError;
}(TokenError);
/** Thrown if the mint of a token account doesn't match the expected mint */

export var TokenInvalidMintError = /*#__PURE__*/function (_TokenError6) {
  _inherits(TokenInvalidMintError, _TokenError6);

  var _super7 = _createSuper(TokenInvalidMintError);

  function TokenInvalidMintError() {
    var _this6;

    _classCallCheck(this, TokenInvalidMintError);

    _this6 = _super7.apply(this, arguments);
    _this6.name = 'TokenInvalidMintError';
    return _this6;
  }

  return TokenInvalidMintError;
}(TokenError);
/** Thrown if the owner of a token account doesn't match the expected owner */

export var TokenInvalidOwnerError = /*#__PURE__*/function (_TokenError7) {
  _inherits(TokenInvalidOwnerError, _TokenError7);

  var _super8 = _createSuper(TokenInvalidOwnerError);

  function TokenInvalidOwnerError() {
    var _this7;

    _classCallCheck(this, TokenInvalidOwnerError);

    _this7 = _super8.apply(this, arguments);
    _this7.name = 'TokenInvalidOwnerError';
    return _this7;
  }

  return TokenInvalidOwnerError;
}(TokenError);
/** Thrown if the owner of a token account is a PDA (Program Derived Address) */

export var TokenOwnerOffCurveError = /*#__PURE__*/function (_TokenError8) {
  _inherits(TokenOwnerOffCurveError, _TokenError8);

  var _super9 = _createSuper(TokenOwnerOffCurveError);

  function TokenOwnerOffCurveError() {
    var _this8;

    _classCallCheck(this, TokenOwnerOffCurveError);

    _this8 = _super9.apply(this, arguments);
    _this8.name = 'TokenOwnerOffCurveError';
    return _this8;
  }

  return TokenOwnerOffCurveError;
}(TokenError);
/** Thrown if an instruction's program is invalid */

export var TokenInvalidInstructionProgramError = /*#__PURE__*/function (_TokenError9) {
  _inherits(TokenInvalidInstructionProgramError, _TokenError9);

  var _super10 = _createSuper(TokenInvalidInstructionProgramError);

  function TokenInvalidInstructionProgramError() {
    var _this9;

    _classCallCheck(this, TokenInvalidInstructionProgramError);

    _this9 = _super10.apply(this, arguments);
    _this9.name = 'TokenInvalidInstructionProgramError';
    return _this9;
  }

  return TokenInvalidInstructionProgramError;
}(TokenError);
/** Thrown if an instruction's keys are invalid */

export var TokenInvalidInstructionKeysError = /*#__PURE__*/function (_TokenError10) {
  _inherits(TokenInvalidInstructionKeysError, _TokenError10);

  var _super11 = _createSuper(TokenInvalidInstructionKeysError);

  function TokenInvalidInstructionKeysError() {
    var _this10;

    _classCallCheck(this, TokenInvalidInstructionKeysError);

    _this10 = _super11.apply(this, arguments);
    _this10.name = 'TokenInvalidInstructionKeysError';
    return _this10;
  }

  return TokenInvalidInstructionKeysError;
}(TokenError);
/** Thrown if an instruction's data is invalid */

export var TokenInvalidInstructionDataError = /*#__PURE__*/function (_TokenError11) {
  _inherits(TokenInvalidInstructionDataError, _TokenError11);

  var _super12 = _createSuper(TokenInvalidInstructionDataError);

  function TokenInvalidInstructionDataError() {
    var _this11;

    _classCallCheck(this, TokenInvalidInstructionDataError);

    _this11 = _super12.apply(this, arguments);
    _this11.name = 'TokenInvalidInstructionDataError';
    return _this11;
  }

  return TokenInvalidInstructionDataError;
}(TokenError);
/** Thrown if an instruction's type is invalid */

export var TokenInvalidInstructionTypeError = /*#__PURE__*/function (_TokenError12) {
  _inherits(TokenInvalidInstructionTypeError, _TokenError12);

  var _super13 = _createSuper(TokenInvalidInstructionTypeError);

  function TokenInvalidInstructionTypeError() {
    var _this12;

    _classCallCheck(this, TokenInvalidInstructionTypeError);

    _this12 = _super13.apply(this, arguments);
    _this12.name = 'TokenInvalidInstructionTypeError';
    return _this12;
  }

  return TokenInvalidInstructionTypeError;
}(TokenError);
/** Thrown if the program does not support the desired instruction */

export var TokenUnsupportedInstructionError = /*#__PURE__*/function (_TokenError13) {
  _inherits(TokenUnsupportedInstructionError, _TokenError13);

  var _super14 = _createSuper(TokenUnsupportedInstructionError);

  function TokenUnsupportedInstructionError() {
    var _this13;

    _classCallCheck(this, TokenUnsupportedInstructionError);

    _this13 = _super14.apply(this, arguments);
    _this13.name = 'TokenUnsupportedInstructionError';
    return _this13;
  }

  return TokenUnsupportedInstructionError;
}(TokenError);
/** Thrown if the transfer hook extra accounts contains an invalid account index */

export var TokenTransferHookAccountNotFound = /*#__PURE__*/function (_TokenError14) {
  _inherits(TokenTransferHookAccountNotFound, _TokenError14);

  var _super15 = _createSuper(TokenTransferHookAccountNotFound);

  function TokenTransferHookAccountNotFound() {
    var _this14;

    _classCallCheck(this, TokenTransferHookAccountNotFound);

    _this14 = _super15.apply(this, arguments);
    _this14.name = 'TokenTransferHookAccountNotFound';
    return _this14;
  }

  return TokenTransferHookAccountNotFound;
}(TokenError);
/** Thrown if the transfer hook extra accounts contains an invalid seed */

export var TokenTransferHookInvalidSeed = /*#__PURE__*/function (_TokenError15) {
  _inherits(TokenTransferHookInvalidSeed, _TokenError15);

  var _super16 = _createSuper(TokenTransferHookInvalidSeed);

  function TokenTransferHookInvalidSeed() {
    var _this15;

    _classCallCheck(this, TokenTransferHookInvalidSeed);

    _this15 = _super16.apply(this, arguments);
    _this15.name = 'TokenTransferHookInvalidSeed';
    return _this15;
  }

  return TokenTransferHookInvalidSeed;
}(TokenError);
/** Thrown if account data required by an extra account meta seed config could not be fetched */

export var TokenTransferHookAccountDataNotFound = /*#__PURE__*/function (_TokenError16) {
  _inherits(TokenTransferHookAccountDataNotFound, _TokenError16);

  var _super17 = _createSuper(TokenTransferHookAccountDataNotFound);

  function TokenTransferHookAccountDataNotFound() {
    var _this16;

    _classCallCheck(this, TokenTransferHookAccountDataNotFound);

    _this16 = _super17.apply(this, arguments);
    _this16.name = 'TokenTransferHookAccountDataNotFound';
    return _this16;
  }

  return TokenTransferHookAccountDataNotFound;
}(TokenError);